import type { MessageToolLinksData } from "@virtual-brain-lib/types";

import { ToolCard, ToolCardSteps } from "../core";
import { ToolCardLinkList } from "./ToolCardLinkList";

export interface ToolCardLinksProps {
	readonly state: MessageToolLinksData;
	readonly className?: string;
}

export function ToolCardLinks({ state, className }: ToolCardLinksProps) {
	const { status, statusText, steps, links, contentReferenceOffset } = state;

	if (status !== "processing" && links.length === 0 && steps.length === 0) {
		return null;
	}

	const getDefaultStatusText = () => {
		if (status === "processing") {
			return "Searching the web";
		}

		const count = links.length;

		if (count === 0) {
			return "No relevant sources found";
		}

		return `Found ${count} relevant source${count > 1 ? "s" : ""} online`;
	};

	const getCompactSummary = () => {
		if (status === "processing") {
			return "Searching online";
		}

		const count = links.length;

		if (count === 0) {
			return "No sources found";
		}

		return `${count} source${count > 1 ? "s" : ""} found`;
	};

	const displayedStatusText = statusText ?? getDefaultStatusText();

	return (
		<ToolCard
			className={className}
			icon="globe"
			status={status}
			statusText={displayedStatusText}
			compactSummary={getCompactSummary()}
			title="Web"
		>
			{steps.length > 0 && <ToolCardSteps steps={steps} />}
			<ToolCardLinkList links={links} contentReferenceOffset={contentReferenceOffset} />
		</ToolCard>
	);
}
